import { API } from './resources'

export default {
  getFromJudgesProjects: (templateIDs, limit, offset, sort, filter, exclude, showHidden, type) => {
    return API.get('/judging/registration_projects', { params: { templateIDs, limit, offset, sort, filter, exclude, showHidden, type } })
  },
  getPollByProjectId: (projectIDs) => {
    return API.get('/poll/project', { params: { projectIDs } })
  },
  getJudgingTeams: (projectIDs) => {
    return API.get('/judging/teams', { params: { projectIDs } })
  },
  getJudgingTeamGroups: () => {
    return API.get('/judging/teamGroups')
  },
  generateJudgingTeams: ({ teamSize, templateIds, teamTemplateId, filterOptions, diversifiedQuestionIds }) => {
    return API.post('/judging/generateTeams', { teamSize, templateIds, teamTemplateId, filterOptions, diversifiedQuestionIds })
  },
  switchTeams: ({ userName, fromTeam, toTeam }) => {
    return API.post('/judging/switchTeam', { userName, fromTeam, toTeam })
  },
  setTeamLead: ({ userName, teamID }) => {
    return API.post('/judging/setTeamLead', { userName, teamID })
  },
  removeTeamLead: ({ userName, teamID }) => {
    return API.post('/judging/removeTeamLead', { userName, teamID })
  },
  removeUserFromTeam: ({ userName, teamID }) => {
    return API.post('/judging/removeUserFromTeam', { userName, teamID })
  },
  getJudgingReport: () => {
    return API.get('/judging/getReport')
  },
  setJudgingTeamLockStatus: function ({ userName, teamID }) {
    return API.get('/judging/setTeamLock', { userName, teamID })
  }
}
